import React from 'react'
import { FormattedMessage } from 'react-intl'

export const REWARD_PER_BATTLE = (
    <FormattedMessage
        id="battle_wizard.reward_per_battle"
        defaultMessage="за каждый бой"
    />
)



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Reward/constants.jsx